const Recaudos = [
    {
        id: 0,
        recaudo: "Carpeta marrón de fibra tamaño oficio, sin ganchos, en buen estado, sin tachaduras, identificada con una etiqueta blanca engomada o adhesiva colocada en la pestaña indicando: Número de la Cédula de Identidad, Apellidos (Primero y Segundo) y nombres. (Letra Arial tamaño 10)."
    },
    {
        id: 1,
        recaudo: "Dos (2) fotografías de frente tamaño carnet, recientes e iguales a color (no instantáneas)."
    },
    {
        id: 2,
        recaudo: "Dos (2) fotocopias de la Cédula de Identidad vigente (Ampliada en hoja tamaño carta)."
    },
    {
        id: 3,
        recaudo: "Original y fotocopia de la partida de nacimiento legible, sin tachadura ni enmienda, formato actual y vigente."
    },
    {
        id: 4,
        recaudo: "Carta buena conducta expedida por el Consejo Comunal, Asociación de Vecinos o Jefatura Civil."
    },
    {
        id: 5,
        recaudo: "Original y Copia del Certificado de Discapacidad emitido por el Consejo Nacional para las Personas con Discapacidad (CONAPDIS), en caso de presentar alguna discapacidad."
    },
    {
        id: 6,
        recaudo: "Original y copia en fondo negro (en papel fotográfico) del Título de Bachiller venezolano. La copia en fondo negro debe ser autenticada al reverso (sello y firma) por la institución de origen o por la Zona Educativa respectiva en caso de que la institución haya cerrado de forma permanente (la autenticación debe ser en original)."
    },
    {
        id: 7,
        recaudo: "Original y copia, en fondo negro (en papel fotográfico) de las notas certificadas de Bachillerato. La copia en fondo negro debe ser autenticada (sello y firma) por la institución de origen o por la Zona Educativa respectiva en caso de que la institución haya cerrado de forma permanente. (La autenticación debe ser en original)."
    },
    {
        id: 8,
        recaudo: "Estudiantes del último año de Educación Media General, pueden consignar las copias de Séptimo a Cuarto Año (7mo a 4to Año)."
    },
    {
        id: 9,
        recaudo: "Copia del Certificado de Participación a la Educación Universitaria (C.N.U) o el Sistema Nacional de Ingreso (SNI), esta constancia se puede obtener a través del portal opsu.gob.ve."
    },
    {
        id: 10,
        recaudo: "Copia del Registro Militar Obligatorio. Según el artículo 80 de la Ley de Conscripción y Alistamiento Militar (LCAM), si es mayor de edad, es decir, con 18 años cumplidos, está en la obligación de presentar ante la autoridad competente o ente privado correspondiente, el documento que acredite su inscripción militar o el haber cumplido con el servicio correspondiente."
    },
    {
        id: 11,
        recaudo: "Los venezolanos con estudios de bachillerato fuera del país, aunque posean Título de Bachiller extranjero NO podrán inscribirse, a menos que hayan concluido la reválida o el reconocimiento de su título, ante el Ministerio del Poder Popular para la Educación y su debida traducción al idioma oficial, esto es al español. Se requiere, por tanto, la convalidación de Título de Bachiller extranjero."
    }
]

export default Recaudos;


// WEBPACK FOOTER //
// ./src/shared/ReacaudosInsc.jsx